export default "__VITE_ASSET__DWwX1Qa1__"